module.exports = __webpack_public_path__ + "static/img/cha5-bg.ab85a20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/cha5-bg.png
// module id = YonC
// module chunks = 1